<script lang="ts" setup>

const { useRef } = useLayoutStore()

const [_, rect] = useRef('header')

const [root] = useRef('root-container')

const anchors = [
  { label: '会社紹介', href: '#brief' },
  { label: '会社情報', href: '#introduce' },
  { label: '事業内容', href: '#service' },
  { label: 'ニュース', href: '#news' },
  { label: 'お問い合わせ', href: '#contact' },
]

const copyright = 'Copyright ITONIFF All Rights Reserved.'

</script>

<template>
  <div id="footer">
    <ADevice>
      <template #h5>
        <MContainer>
          <MCol class=" py-12 border-t items-center gap-6">
            <ALink to="/"><img class=" h-6" src="https://static-jp.theckb.com/static-asset/xr/X&R_1.svg" alt=""></ALink>
            <AAnchor path="/" class=" w-[100%] flex justify-between" :anchors="anchors" :offset="rect.height"
              :container="root">
              <template #default="{ item }">
                <MText size="md" class="!text-[13px] rounded transition-colors">
                  {{ item.label }}
                </MText>
              </template>
            </AAnchor>
            <MText class=" text-[#00000073]">
              {{ copyright }}
            </MText>
          </MCol>
        </MContainer>
      </template>
      <template #pc>
        <AContainer>
          <div class="w-[1320px] border-t border-black/25 py-[48px]">
            <div class="flex justify-between">
              <ALink to="/" class="py-[16px]"> <img src="https://static-jp.theckb.com/static-asset/xr/X&R.svg" alt="">
              </ALink>
              <div class="flex justify-center items-center">
                <AAnchor path="/" class=" w-[100%] grid grid-cols-5 gap-[40px]" :anchors="anchors" :offset="rect.height"
                  :container="root">
                  <template #default="{ item }">
                    <MText size="base" class="rounded transition-colors">
                      {{ item.label }}
                    </MText>
                  </template>
                </AAnchor>
              </div>
            </div>
            <div class="text-[12px] leading-[22px] text-black/45 mt-[16px]">Copyright ITONIFF All Rights Reserved.
            </div>
          </div>
        </AContainer>
      </template>
    </ADevice>
  </div>
</template>

<style lang="scss" scoped></style>
